import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles(() => ({
  container: {
    width: 450,
  },
  bodyContainer: {
    marginTop: 100,
    marginBottom: 20,
    justifyContent: 'center',
  },
}));
